export default {
  slider: {
    base: {
      appearance: 'none',
      height: '4px',
      m: '0px',
      verticalAlign: 'middle',
      width: '100%',
      '::-webkit-slider-thumb': {
        variant: 'spark.element.slider.thumb.base'
      },
      '::-moz-range-thumb': {
        variant: 'spark.element.slider.thumb.base'
      }
    }
  },
  thumb: {
    base: {
      appearance: 'none',
      cursor: 'pointer',
      backgroundColor: 'grey-100',
      width: '24px',
      height: '24px',
      border: 'none',
      borderRadius: '50%'
    }
  },
  wrapper: {
    base: {
      display: 'inline-block',
      height: '26px',
      lineHeight: '24px',
      variant: 'spark.base.wrapper'
    }
  }
};